import classes from './label.module.css';

export interface LabelProps {
	name: string | undefined,
	text: string | undefined
}

function Label(props: LabelProps) {
	return (
		<label htmlFor={props.name} className='control-label'>{props.text}</label>
	);
}

export default Label;